import React from "react";
import styles from "./RecommendationsPrice.module.css";
import { formatPrice } from "../../utils/priceHelpers";
import { useViewModel } from "../../hooks/useViewModel";

interface RecommendationsPriceProps {
	priceFormatted: string;
	monthlyPriceFormatted?: string;
	savings?: number;
	priceBefore?: number;
	locale?: string;
}

const RecommendationsPrice: React.FC<RecommendationsPriceProps> = ({
	priceFormatted,
	monthlyPriceFormatted,
	savings,
	priceBefore,
	locale = "nb-NO",
}) => {
	const { data } = useViewModel();
	const { strings } = data!;

	const hasSavings = savings != null && savings > 0;

	return (
		<div className={styles.container}>
			<span className={styles.price}>{priceFormatted}</span>
			{monthlyPriceFormatted && (
				<span className={styles.monthly}>
					<span className={styles.flex}>FLEX</span> {monthlyPriceFormatted}
				</span>
			)}
			{hasSavings && (
				<span className={styles.savings}>
					{strings.product.configBundles.priceSaved.replace(
						"{VALUE}",
						String(formatPrice(savings, locale)),
					)}
				</span>
			)}
			{hasSavings && priceBefore && (
				<span className={styles.before}>
					{strings.product.configBundles.priceFrom.replace(
						"{VALUE}",
						String(formatPrice(priceBefore, locale)),
					)}
				</span>
			)}
		</div>
	);
};

export default RecommendationsPrice;